import {
  AdministradorDto,
  AdministradorServiceProxy,
  CandidatoDto,
  CandidatoServiceProxy,
  EmpresaDto,
  EmpresaServiceProxy,
  OnboardingCandidatoServiceProxy,
} from "../../../../service-proxies/service-proxies";
import { AppAuthService } from "./../../../../auth/app-auth.service";
import { EmpresaService } from "./../../../../../empresa/service/empresa.service";

import { AppComponentBase } from "../../../../app-component-base";
import { finalize, Subscription } from "rxjs";
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Injector,
  Input,
} from "@angular/core";
import { CandidatoService } from "candidato/service/candidato.service";
import { Router } from "@node_modules/@angular/router";
import { BsModalService } from "@node_modules/ngx-bootstrap/modal";
import { LayoutStoreService } from "@shared/layout/layout-store.service";
@Component({
  selector: "sidebar-user-menu",
  templateUrl: "./sidebar-user-menu.component.html",
  styleUrls: ["./sidebar-user-menu.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MainSidebarUserMenuComponent extends AppComponentBase {
  empresaDto: EmpresaDto;
  candidatoDto: CandidatoDto = new CandidatoDto();
  administradorDto: AdministradorDto = new AdministradorDto();
  private empresaSub: Subscription = new Subscription();
  @Input() route: String;
  sidebarExpanded: boolean;

  constructor(
    private injector: Injector,
    private _authService: AppAuthService,
    private cdr: ChangeDetectorRef,
    public empresaService: EmpresaService,
    private _empresaService: EmpresaServiceProxy,
    private _candidatoService: CandidatoServiceProxy,
    public candidatoService: CandidatoService,
    private _router: Router,
    private _onboardingCandidatoServiceProxy: OnboardingCandidatoServiceProxy,
    private _modalService: BsModalService,
    private _administradorService: AdministradorServiceProxy,
    private _layoutStore: LayoutStoreService
  ) {
    super(injector);
  }

  ngOnInit(): void {
    switch (this.route) {
      case "empresa":
        this.getEmpresa();
        break;
      case "candidato":
        this.getCandidato();
        break;
      case "administrativo":
        this.getAdministrador();
        break;
      default:
    }

    this.empresaSub = this.empresaService
      .getEmpresaUpdateListener()
      .subscribe((empresa: EmpresaDto) => {
        this.empresaDto = empresa;
        this.cdr.markForCheck();
      });

    this._layoutStore.sidebarExpanded.subscribe((value) => {
      this.sidebarExpanded = value;
    });
  }

  termosLink(): string {
    switch (this.route) {
      case "candidato":
        return "/candidato/termos-de-uso";
      case "empresa":
        return "/empresa/termos-de-uso";
      case "empresa-especial":
        return "/empresa-especial/termos-de-uso";
      case "administrativo":
        return "/administrativo/termos-de-uso";
      default:
        return "/default/termos-de-uso";
    }
  }
  politicasLink(): string {
    switch (this.route) {
      case "candidato":
        return "/candidato/politica-de-privacidade";
      case "empresa":
        return "/empresa/politica-de-privacidade";
      case "empresa-especial":
        return "/empresa-especial/politica-de-privacidade";
      case "administrativo":
        return "/administrativo/politica-de-privacidade";
      default:
        return "/default/politica-de-privacidade";
    }
  }

  ngOnDestroy(): void {
    if (this.empresaSub) {
      this.empresaSub.unsubscribe();
    }
  }

  logout(): void {
    this._authService.logout();
  }

  getEmpresa() {
    this._empresaService
      .getAbp()
      .pipe(finalize(() => {}))
      .subscribe((response: EmpresaDto) => {
        this.empresaDto = response;
        this.getProfileImage();
        this.cdr.markForCheck();
        this.cdr.detectChanges();
      });
  }

  getCandidato() {
    abp.ui.setBusy();
    this._candidatoService
      .getAbp()
      .pipe(
        finalize(() => {
          abp.ui.clearBusy();
        })
      )
      .subscribe((candidato) => {
        this.getProfileImage();
        this.candidatoDto = candidato;
        this.candidatoService.setCandidato(candidato);
        this.cdr.detectChanges();
        if (
          candidato.rendaBrutaFamiliarString &&
          candidato.rendaBrutaFamiliarEnum <= 8
        ) {
          this._router.navigate(["candidato", "perfil"]);
        } else if (
          candidato.curriculoDadoPessoal &&
          !candidato.curriculoDadoPessoal.corRacaString
        ) {
          this._router.navigate(["candidato", "meu-curriculo"]);
        }
      });
  }

  getAdministrador() {
    abp.ui.setBusy();
    this._administradorService
      .getAbp()
      .pipe(
        finalize(() => {
          abp.ui.clearBusy();
        })
      )
      .subscribe((response) => {
        this.administradorDto = response;
        this.getProfileImage();
      });
  }

  getProfileImage(): string {
    switch (this.route) {
      case "candidato":
        return (
          this.candidatoDto?.urlFotoPerfilDesbloqueado ??
          "../../../../../assets/img/user-void.png"
        );
      case "empresa":
        return (
          this.empresaDto?.urlFotoPerfilDesbloqueado ??
          "../../../../../assets/img/user-void.png"
        );
      case "empresa-especial":
        return (
          this.empresaDto?.urlFotoPerfilDesbloqueado ??
          "../../../../../assets/img/user-void.png"
        );
      case "administrativo":
        return this.administradorDto.urlFotoPerfil
          ? this.administradorDto.urlFotoPerfil
          : "../../../../../assets/img/user-void.png";
      default:
        return "../../../../../assets/img/user-void.png";
    }
  }

  isCircleImage(): boolean {
    switch (this.route) {
      case "candidato":
        return this.candidatoDto?.urlFotoPerfilDesbloqueado != null;
      case "empresa":
        return this.empresaDto?.urlFotoPerfilDesbloqueado != null;
      case "empresa-especial":
        return this.empresaDto?.urlFotoPerfilDesbloqueado != null;
      case "administrativo":
        return this.administradorDto?.urlFotoPerfil != null;
      default:
        return false;
    }
  }
}
